import * as S from './styles';
import Spin from 'components/Spin';
import { useIsMobile } from 'utils/mediaQueries';

interface YoutubeVideoEmbedProps {
  videoId: string;
  videoLoading: boolean;
  onLoad: () => void;
}

export const YoutubeVideoEmbed = ({ videoId, videoLoading, onLoad }: YoutubeVideoEmbedProps) => {
  const isMobile = useIsMobile();

  const treatVideoId = (videoId: string) => {
    if (videoId.includes('youtu.be')) {
      return videoId.split('/').pop();
    } else if (videoId.includes('youtube.com')) {
      if (videoId.includes('watch?v=')) {
        return videoId.split('watch?v=')[1];
      } else if (videoId.includes('v=')) {
        return videoId.split('v=')[1];
      } else if (videoId.includes('embed/')) {
        return videoId.split('embed/')[1];
      } else if (videoId.includes('live/')) {
        return videoId.split('live/')[1];
      }
    }
    return videoId;
  };

  return (
    <S.VideoContainer isMobile={isMobile}>
      {videoLoading && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin tip="Loading video..." />
        </div>
      )}
      <iframe
        width="100%"
        height="100%"
        src={`https://youtube.com/embed/${treatVideoId(videoId)}`}
        title="YouTube video player"
        onLoad={onLoad}
        style={{ display: videoLoading ? 'none' : 'block' }}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </S.VideoContainer>
  );
};
